import React from "react";
import "./Business.css";

const Business = () => {
  const businessProducts = [
    {
      id: 1,
      name: "Payroll Management System",
      description: "Streamline your payroll processing with our comprehensive solution that handles everything from salary calculations to tax compliance.",
      features: [
        "Automated salary calculations",
        "Tax deduction and compliance",
        "Employee self-service portal",
        "Multiple payment methods",
        "Leave and attendance integration",
        "Custom report generation"
      ],
      expectations: [
        "Reduced payroll processing time by 70%",
        "100% tax compliance assurance",
        "Real-time payroll analytics",
        "Seamless integration with existing HR systems"
      ],
      customization: [
        "Custom payroll cycles",
        "Region-specific tax configurations",
        "Branded employee portals",
        "API integrations with accounting software"
      ]
    },
    {
      id: 2,
      name: "HRMS",
      description: "Comprehensive Human Resource Management System to manage your workforce efficiently.",
      features: [
        "Employee database management",
        "Recruitment and onboarding",
        "Performance evaluation",
        "Leave and attendance tracking",
        "Training and development",
        "Workforce analytics"
      ],
      expectations: [
        "Centralized employee data management",
        "Streamlined HR processes",
        "Improved employee engagement",
        "Data-driven decision making"
      ],
      customization: [
        "Custom workflow configurations",
        "Company policy integrations",
        "Multi-location support",
        "Mobile app for employees"
      ]
    },
    {
      id: 3,
      name: "CRM",
      description: "Powerful Customer Relationship Management system to enhance customer interactions and sales.",
      features: [
        "Contact and lead management",
        "Sales pipeline tracking",
        "Customer interaction history",
        "Marketing automation",
        "Reporting and analytics",
        "Mobile access"
      ],
      expectations: [
        "Improved customer relationships",
        "Increased sales conversion rates",
        "Better marketing ROI",
        "360-degree customer view"
      ],
      customization: [
        "Industry-specific templates",
        "Custom sales stages",
        "Integration with email and social media",
        "Advanced segmentation"
      ]
    },
    {
      id: 4,
      name: "ERP for SMEs",
      description: "Enterprise Resource Planning solution tailored for small and medium businesses.",
      features: [
        "Financial management",
        "Inventory control",
        "Supply chain management",
        "Manufacturing modules",
        "Project management",
        "Business intelligence"
      ],
      expectations: [
        "Integrated business processes",
        "Real-time data visibility",
        "Improved operational efficiency",
        "Scalable business growth"
      ],
      customization: [
        "Module-based implementation",
        "Industry-specific configurations",
        "Third-party integrations",
        "Custom reporting"
      ]
    },
    {
      id: 5,
      name: "Inventory & Billing System",
      description: "Complete solution for inventory control and billing operations.",
      features: [
        "Stock level monitoring",
        "Purchase order management",
        "Barcode scanning",
        "Multi-location inventory",
        "Invoice generation",
        "Tax compliance"
      ],
      expectations: [
        "Real-time inventory tracking",
        "Reduced stockouts and overstocking",
        "Faster billing processes",
        "Accurate financial reporting"
      ],
      customization: [
        "Custom inventory categories",
        "Vendor management",
        "Batch and expiry tracking",
        "POS integration"
      ]
    },
    {
      id: 6,
      name: "POS System",
      description: "Modern Point of Sale system for retail and hospitality businesses.",
      features: [
        "Sales transaction processing",
        "Payment processing",
        "Customer management",
        "Receipt printing",
        "Inventory updates",
        "Sales reporting"
      ],
      expectations: [
        "Faster checkout processes",
        "Improved customer experience",
        "Accurate sales tracking",
        "Integrated inventory management"
      ],
      customization: [
        "Hardware compatibility",
        "Custom receipt templates",
        "Loyalty program integration",
        "Offline mode capability"
      ]
    },
    {
      id: 7,
      name: "Invoice & Quotation Builder",
      description: "Professional invoicing and quotation creation tool for businesses.",
      features: [
        "Customizable templates",
        "Automatic calculations",
        "Tax compliance",
        "Client management",
        "Payment tracking",
        "Multi-currency support"
      ],
      expectations: [
        "Professional-looking documents",
        "Faster billing cycles",
        "Improved cash flow",
        "Reduced billing errors"
      ],
      customization: [
        "Branded templates",
        "Recurring invoices",
        "Online payment integration",
        "Approval workflows"
      ]
    },
    {
      id: 8,
      name: "Project Management Tool",
      description: "Collaborative platform for planning and executing projects efficiently.",
      features: [
        "Task management",
        "Team collaboration",
        "Gantt charts",
        "Time tracking",
        "File sharing",
        "Progress reporting"
      ],
      expectations: [
        "Improved project visibility",
        "Better team coordination",
        "On-time project delivery",
        "Resource optimization"
      ],
      customization: [
        "Custom workflows",
        "Client portals",
        "Integration with other tools",
        "Role-based access"
      ]
    },
    {
      id: 9,
      name: "Vendor Management System",
      description: "Streamline your vendor relationships and procurement processes.",
      features: [
        "Vendor database",
        "Contract management",
        "Purchase order tracking",
        "Performance evaluation",
        "Payment processing",
        "Compliance monitoring"
      ],
      expectations: [
        "Better vendor relationships",
        "Cost savings",
        "Process efficiency",
        "Risk mitigation"
      ],
      customization: [
        "Custom evaluation criteria",
        "Approval workflows",
        "Integration with accounting",
        "Document management"
      ]
    }
  ];

  return (
    <div className="business-container">
      <div className="business-header">
        <h1>Business & Operations Solutions</h1>
        <p className="subtitle">Streamline your business processes with our comprehensive operational tools</p>
      </div>

      <div className="business-grid">
        {businessProducts.map((product) => (
          <div key={product.id} className="business-card">
            <div className="business-card-header">
              <h2>{product.name}</h2>
              <p className="business-card-description">{product.description}</p>
            </div>

            <div className="business-card-details">
              <div className="business-card-section">
                <h3>Key Features</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="business-card-section">
                <h3>What you can Expect</h3>
                <ul>
                  {product.expectations.map((expectation, index) => (
                    <li key={index}>{expectation}</li>
                  ))}
                </ul>
              </div>

              <div className="business-card-section">
                <h3>Customization Options</h3>
                <ul>
                  {product.customization.map((option, index) => (
                    <li key={index}>{option}</li>
                  ))}
                </ul>
              </div>
            </div>

      {/*
<div className="business-card-footer">
  <button className="business-demo-button">Request Demo</button>
</div>
*/}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Business;